import React, { useState, useEffect, useRef } from "react"
import '../../assets/css/views/activities/esfCoverage.css'
import { useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Button, Modal, ButtonGroup, TextArea, Card, RadioButtons, RadioButton, IconChevronDown, ListItem, IconChevronRight, Select, SelectOption, Tooltip, IconInfo, IconCheckmarkCircle, IconXCircle } from "@veneer/core";
import { Accordion, AccordionDetails, AccordionSummary } from "@mui/material";
import { useSelector } from "react-redux";
import { RootState } from "../../app/store";
import BackButton from "../../features/path/backButton";
import LoaderModal from "../../components/Loader/loaderModal";
import SimpleMessageModalWithOpenClose from "../../components/Modals/SimpleMessageModalWithOpenClose";
import { BreadCrumbsEnum } from "../../models/enum/BreadCrumbsEnum";
import { AdvisorType } from "../../models/enum/AdvisorTypeEnum";
import { AttendanceRate } from "../../models/enum/AttendanceRateEnum";
import esfCoverageService from "../../services/agendaApi/esfCoverage.service";
import { IAppointmentDto } from "../../models/dto/agendaApi/IAppointmentDto";
import appointmentService from "../../services/agendaApi/appointment.service";
import salesService from "../../services/agendaApi/sales.service";
import { IBrandDto } from "../../models/dto/agendaApi/IBrandDto";
import { IEsfCoverageAdvisorDetailsTemp, IEsfCoverageAdvisorTemp, IEsfCoverageDto, IEsfCoverageLovDto, IEsfCoverageTemp, IEsfCoverageTypeDto } from "../../models/dto/generalApi/IEsfCoverageDto";
import { IEsfCoverageDetails, IEsfCoverageIn } from "../../models/input/generalApi/IEsfCoverageIn";

interface WeekdayMultiSelectProps {
  label: string;
  options: SelectOption[];
  value: number[];
  onChange: (v: number) => void;
  onClear: () => void;
}

function WeekdayMultiSelect({ label, options, value, onChange, onClear }: WeekdayMultiSelectProps) {
  const [portalEl, setPortalEl] = React.useState<HTMLElement | null>(null);
  return (
    <div className="esfCoverageWeekdayWrapper" ref={setPortalEl}>
      {portalEl && (
        <Select
          className="esfCoverageWeekdaySelect"
          label={label}
          multiple
          placement="bottom"
          options={options}
          value={value}
          portalContainer={portalEl}
          onChange={(e: any) => onChange(e.value as number)}
          onClear={onClear}
          i18n={{ selected: '', unselected: '' } as any}
        />
      )}
    </div>
  );
}


export default function EsfCoverage() {

  const params = useParams();
  const [t] = useTranslation("global");
  const languageId: any = useSelector((state: RootState) => state.languageId);
  type SelectValue = number | string | boolean; //CHECK
  const navigate = useNavigate();

  const actualPosCode = useRef('');
  const isFirstRender = useRef(true);
  const isDataReady = useRef(false);

  const [appointmentActivityId, setAppointmentActivityId] = useState(NaN);
  const [activityId, setActivityId] = useState(NaN);

  //Data
  const [brands, setBrands] = useState<IEsfCoverageTemp[]>([]);
  const [advisorsData, setAdvisorsData] = useState<IEsfCoverageAdvisorTemp[]>([]);
  const [optionsAdvisors, setOptionsAdvisors] = useState<SelectOption[]>([]);
  const [validations, setValidations] = useState<any[]>([]);


  const [saveDisable, setSaveDisable] = useState(true);
  const [isDirty, setIsDirty] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);


  useEffect(() => {
    getPosCode()
    let id = Number(params.id);
    let activityId = Number(params.activityId);
    setActivityId(id)
    setAppointmentActivityId(activityId);
  }, [])

  useEffect(() => {
    let validation = brands.map((brand, index) => {
      const rotaryDetail = brand.esfCoverageDetails.find(d => d.typeID === 2);
      const rotaryFilled = rotaryDetail && rotaryDetail.quantity.length !== 0 && Number(rotaryDetail.quantity[0]) !== 0;

      if (!rotaryFilled) {
        return { 'brandId': brand.brandID, 'status': 3 }
      }

      let actualAdvisor = advisorsData.find(item => item.brandID === brand.brandID);
      const allAdvisorsComplete = actualAdvisor?.advisorDetails.every(detail =>
        detail.advisorType &&
        detail.attendanceRate &&
        (detail.monday || detail.tuesday || detail.wednesday || detail.thursday || detail.friday || detail.saturday || detail.sunday)
      );
      if (allAdvisorsComplete) {
        return { 'brandId': brand.brandID, 'status': 1 }
      } else {
        return { 'brandId': brand.brandID, 'status': 2 }
      }
    })
    setValidations(validation)
    const anyQuantityFilled = brands.some(brand => brand.esfCoverageDetails.some(d => d.quantity.length !== 0));
    const hasIncompleteMandatoryFields = !isDataReady.current ||
      !isDirty ||
      !anyQuantityFilled ||
      advisorsData.some(advisor =>
        advisor.advisorDetails.some(detail =>
          !detail.advisorType ||
          !detail.attendanceRate ||
          (!detail.monday && !detail.tuesday && !detail.wednesday &&
            !detail.thursday && !detail.friday && !detail.saturday && !detail.sunday)
        )
      );
    setSaveDisable(hasIncompleteMandatoryFields);
  }, [brands, advisorsData, isDirty])

  useEffect(() => {
    if (isFirstRender.current && brands.length !== 0 && optionsAdvisors.length !== 0) {
      getEsfCoverage()
      isFirstRender.current = false;
    }
  }, [brands, optionsAdvisors])


  const getEsfCoverage = () => {
    setIsLoading(true);
    esfCoverageService.getEsfCoverage()
      .then(r => {
        fillInfoEsfCoverage(r)
      }).finally(() => {
        isDataReady.current = true;
        setIsLoading(false);
      });

  }

  const getPosCode = () => {
    let id = Number(params.id);
    let appointmentResponse: IAppointmentDto[] = [];
    appointmentService.getAppointmentByUser()
      .then(r => {
        appointmentResponse = r;
      }).finally(() => {
        let posCode = appointmentResponse.find(x => x.appointmentId === id)?.posCode;
        if (posCode) {
          actualPosCode.current = posCode;
          getData(posCode);
        } else { alert("Error") }

      })
  }

  const getData = (posCode: string) => {
    esfCoverageService.getEsfCoverageType(languageId.value).then(responseType => {
      salesService.getBrandsByPos(posCode).then(brands => {
        const brandsFiltered = brands.filter((item:any) => item.brandID !== 1)
        fillBrands(brandsFiltered, responseType);
      });
    }).then(() => {
      esfCoverageService.getEsfCoverageLov().then(r => {
        fillOptions(r)
      })
    })
  }

  const fillBrands = (data: IBrandDto[], responseType: IEsfCoverageTypeDto[]) => {
    const brandsTemp: IEsfCoverageTemp[] = [];
    for (let i = 0; i < data.length; i++) {
      const brand: IBrandDto = data[i];
      let brandTemp: IEsfCoverageTemp;
      brandTemp = {
        'brandID': brand.brandID,
        'brandName': brand.brandName,
        'esfCoverageDetails': responseType.map((item: IEsfCoverageTypeDto) => {
          return {
            typeID: item.esF_CoverageTypeID,
            label: item.label,
            quantity: [],
          }
        })

      }
      brandsTemp.push(brandTemp);
    }
    setBrands(brandsTemp);

  }

  const fillOptions = (data: IEsfCoverageLovDto[]) => {
    const advisorsTemp: SelectOption[] = [];
    for (let i = 0; i < data.length; i++) {
      const item: IEsfCoverageLovDto = data[i];
      if (item.field === "QUANTITY") {
        advisorsTemp.push({ 'value': item.value, 'label': String(item.value) });
      }
    }
    setOptionsAdvisors(advisorsTemp);
  }


  const fillInfoEsfCoverage = (data: IEsfCoverageDto[]) => {
    const filtered = data.filter(datas => datas.poS_Code === actualPosCode.current);
    if (filtered.length === 0) return;

    // Build updated brands state in one pass (avoids stale closure)
    const brandsTemp = [...brands];
    filtered.forEach((record) => {
      const brandIndex = brandsTemp.findIndex(b => b.brandID === record.brandID);
      if (brandIndex === -1) return;
      const detail = brandsTemp[brandIndex].esfCoverageDetails.find(d => d.typeID === record.esF_CoverageTypeID);
      if (!detail) return;
      if (record.esF_CoverageTypeID === 1) {
        detail.quantity = [record.quantity];
      } else if (record.esF_CoverageTypeID === 2) {
        detail.quantity = [Number(detail.quantity[0] ?? 0) + record.quantity];
      }
    });
    setBrands([...brandsTemp]);

    // Build advisor details in one pass from typeID=2 records (avoids stale closure)
    const advisorDataTemp: IEsfCoverageAdvisorTemp[] = [];
    filtered.filter(r => r.esF_CoverageTypeID === 2).forEach((record) => {
      const { monday: monday, tuesday: tuesday, wednesday: wednesday, thursday: thursday, friday: friday, saturday: saturday, sunday: sunday } = record;
      const advisorDetail: IEsfCoverageAdvisorDetailsTemp = {
        advisorType: record.advisorType ?? 0,
        attendanceRate: record.attendanceRate ?? 0,
        monday,
        tuesday,
        wednesday,
        thursday,
        friday,
        saturday,
        sunday,
      };
      const existing = advisorDataTemp.find(a => a.brandID === record.brandID);
      if (existing) {
        existing.advisorDetails.push(advisorDetail);
      } else {
        advisorDataTemp.push({ brandID: record.brandID, advisorDetails: [advisorDetail] });
      }
    });
    if (advisorDataTemp.length > 0) {
      setAdvisorsData([...advisorDataTemp]);
    }
  }

  const blankAdvisorDetail = (): IEsfCoverageAdvisorDetailsTemp => ({
    advisorType: 0,
    attendanceRate: 0,
    monday: false, tuesday: false, wednesday: false,
    thursday: false, friday: false, saturday: false, sunday: false
  });

  const handleChangeChargeAdvisor = (brandID: number) => {
    let advisorDataTemp = advisorsData;
    let itemActual = advisorDataTemp.find(item => item.brandID == brandID);
    if (itemActual) {
      let details: IEsfCoverageAdvisorDetailsTemp[] = itemActual.advisorDetails;
      details.push(blankAdvisorDetail());
      advisorDataTemp.find(item => item.brandID == brandID)!.advisorDetails = details;
      setAdvisorsData([...advisorDataTemp])
    } else {
      let newItem: IEsfCoverageAdvisorTemp;
      let newDetails: IEsfCoverageAdvisorDetailsTemp[] = [blankAdvisorDetail()];
      newItem = {
        'brandID': brandID,
        'advisorDetails': newDetails
      }
      advisorDataTemp.push(newItem);
      setAdvisorsData([...advisorDataTemp])
    }
  }


  const handleChangeSelectFixed = (value: SelectValue, brandID: number, typeID: number) => {
    let brandsTemp = brands;
    let indexActual = brandsTemp.findIndex(item => item.brandID == brandID);
    let item = brandsTemp[indexActual].esfCoverageDetails.find(detail => detail.typeID == typeID);
    if (item) {
      item!.quantity = [value];
    }
    setBrands([...brandsTemp])
    setIsDirty(true);
  }

  const handleChangeClear = (brandID: number, typeID: number) => {
    let brandsTemp = brands;
    let advisorDataTemp = advisorsData;

    let indexActual = brandsTemp.findIndex(item => item.brandID == brandID);
    let item = brandsTemp[indexActual].esfCoverageDetails.find(detail => detail.typeID == typeID);
    if (item) {
      item!.quantity = [];
    }
    if (typeID === 2) {
      advisorDataTemp = advisorDataTemp.filter(item => item.brandID !== brandID);
      setAdvisorsData([...advisorDataTemp])
    }

    setBrands([...brandsTemp])
    setIsDirty(true);
  }


  const handleChangeSelectRotary = (value: SelectValue, brandID: number, typeID: number) => {
    let brandsTemp = brands;
    let indexActual = brandsTemp.findIndex(item => item.brandID == brandID);
    let item = brandsTemp[indexActual].esfCoverageDetails.find(detail => detail.typeID == typeID);
    if (item) {
      item!.quantity = [value];
    }
    setBrands([...brandsTemp])
    setIsDirty(true);
    handleChangeAdvisorData(brandID, Number(value));
  }

  const handleChangeAdvisorType = (value: string, brandID: number, index: number) => {
    const advisorDataTemp = [...advisorsData];
    const itemActual = advisorDataTemp.find(item => item.brandID === brandID);
    if (itemActual) {
      itemActual.advisorDetails[index].advisorType = Number(value);
      setAdvisorsData([...advisorDataTemp]);
      setIsDirty(true);
    }
  }

  const handleChangeAttendanceRate = (value: string, brandID: number, index: number) => {
    const advisorDataTemp = [...advisorsData];
    const itemActual = advisorDataTemp.find(item => item.brandID === brandID);
    if (itemActual) {
      itemActual.advisorDetails[index].attendanceRate = Number(value);
      setAdvisorsData([...advisorDataTemp]);
      setIsDirty(true);
    }
  }

  const handleChangeAdvisorWeekdays = (toggledValue: number, brandID: number, index: number) => {
    let advisorDataTemp = [...advisorsData];
    let itemActual = advisorDataTemp.find(item => item.brandID == brandID);
    if (itemActual) {
      const detail = itemActual.advisorDetails[index];
      const current = [
        ...(detail.monday ? [1] : []),
        ...(detail.tuesday ? [2] : []),
        ...(detail.wednesday ? [3] : []),
        ...(detail.thursday ? [4] : []),
        ...(detail.friday ? [5] : []),
        ...(detail.saturday ? [6] : []),
        ...(detail.sunday ? [7] : []),
      ];
      const updated = current.includes(toggledValue)
        ? current.filter(v => v !== toggledValue)
        : [...current, toggledValue];
      detail.monday = updated.includes(1);
      detail.tuesday = updated.includes(2);
      detail.wednesday = updated.includes(3);
      detail.thursday = updated.includes(4);
      detail.friday = updated.includes(5);
      detail.saturday = updated.includes(6);
      detail.sunday = updated.includes(7);
      setAdvisorsData([...advisorDataTemp]);
      setIsDirty(true);
    }
  }

  const handleClearAdvisorWeekdays = (brandID: number, index: number) => {
    let advisorDataTemp = [...advisorsData];
    let itemActual = advisorDataTemp.find(item => item.brandID == brandID);
    if (itemActual) {
      const detail = itemActual.advisorDetails[index];
      detail.monday = false;
      detail.tuesday = false;
      detail.wednesday = false;
      detail.thursday = false;
      detail.friday = false;
      detail.saturday = false;
      detail.sunday = false;
      setAdvisorsData([...advisorDataTemp]);
      setIsDirty(true);
    }
  }


  const handleChangeAdvisorData = (brandID: number, value: number) => {
    let advisorDataTemp = advisorsData;
    let itemActual = advisorDataTemp.find(item => item.brandID == brandID);

    if (itemActual) {
      if (Number(value) === 0) {
        advisorDataTemp = advisorDataTemp.filter(item => item.brandID !== itemActual?.brandID);
        setAdvisorsData([...advisorDataTemp])
      } else {
        if (Number(value) > itemActual.advisorDetails.length) {
          let difference = Number(value) - itemActual.advisorDetails.length;
          let details: IEsfCoverageAdvisorDetailsTemp[] = itemActual.advisorDetails;
          for (let i = 0; i < difference; i++) {
            details.push(blankAdvisorDetail())
          }
          advisorDataTemp.find(item => item.brandID == brandID)!.advisorDetails = details;
          setAdvisorsData([...advisorDataTemp])

        } else if (Number(value) < itemActual.advisorDetails.length) {
          let difference = itemActual.advisorDetails.length - Number(value);
          let details: IEsfCoverageAdvisorDetailsTemp[] = itemActual.advisorDetails;
          for (let i = 0; i < difference; i++) {
            details.pop()
          }
          advisorDataTemp.find(item => item.brandID == brandID)!.advisorDetails = details;
          setAdvisorsData([...advisorDataTemp])

        }
      }
    } else {
      if (Number(value) !== 0) {
        let newItem: IEsfCoverageAdvisorTemp;
        let newDetails: IEsfCoverageAdvisorDetailsTemp[] = [];
        for (let i = 0; i < value; i++) {
          newDetails.push(blankAdvisorDetail())
        }
        newItem = {
          'brandID': brandID,
          'advisorDetails': newDetails
        }
        advisorDataTemp.push(newItem);
        setAdvisorsData([...advisorDataTemp])
      }
    }
  }


  const onSaveEsfCoverage = () => {
    let esfCoverageIn: IEsfCoverageIn[] = [];
    let esfCoverageDetailsTemp: IEsfCoverageDetails[] = [];

    let date = new Date()
    for (let i = 0; i < brands.length; i++) {
      let esfCoverageDetailsIn: IEsfCoverageDetails[] = [];

      let brandTemp = brands[i];
      let detailsTemp = brands[i].esfCoverageDetails;
      detailsTemp.map((detail, indexDetails) => {
        if (detail.quantity.length !== 0) {
          if (detail.typeID === 2) {
            let advisorDataTemp = advisorsData.find(data => data.brandID === brandTemp.brandID);
            advisorDataTemp?.advisorDetails.filter(data =>
              data.monday || data.tuesday ||
              data.wednesday || data.thursday || data.friday ||
              data.saturday || data.sunday
            ).map((data, indexData) => {
              esfCoverageDetailsIn.push({
                brandID: brandTemp.brandID,
                typeID: detail.typeID,
                quantity: 1,
                monday: data.monday,
                tuesday: data.tuesday,
                wednesday: data.wednesday,
                thursday: data.thursday,
                friday: data.friday,
                saturday: data.saturday,
                sunday: data.sunday,
                advisorType: data.advisorType,
                attendanceRate: data.attendanceRate
              })
            })
          } else {
            esfCoverageDetailsIn.push({
              brandID: brandTemp.brandID,
              typeID: detail.typeID,
              quantity: Number(detail.quantity),
              monday: false,
              tuesday: false,
              wednesday: false,
              thursday: false,
              friday: false,
              saturday: false,
              sunday: false,
              advisorType: 0,
              attendanceRate: 0
            })

          }
        }
      })

      if (esfCoverageDetailsIn.length !== 0) {
        esfCoverageDetailsIn.map((details, index) => { esfCoverageDetailsTemp.push(details) })
      }

    }

    esfCoverageIn.push({
      appointmentActivityID: appointmentActivityId,
      dateTime: date.toISOString(),
      esfCoverageDetails: esfCoverageDetailsTemp,
    })

    setIsLoading(true);
    esfCoverageService.insertEsfCoverage(esfCoverageIn)
      .then(r => {
        isFirstRender.current = true;
        isDataReady.current = false;
        setIsDirty(false);
        setShowSuccess(true);
        setBrands([])
        setAdvisorsData([])
        getData(actualPosCode.current)
      }).finally(() => {
        setIsLoading(false);
      })

  }







  return (
    <>
      {isLoading && <LoaderModal />}
      <div className="esfCoverage">
        <BackButton route={BreadCrumbsEnum.ESFCoverage} activityId={activityId} appointmentActivityId={appointmentActivityId} />
        <h4 className="esfCoverageTitle">{t("header.esfCoverageTitle")}</h4>

        <Card
          appearance="outlined"
          className="esfCoverageRegisterInformation"
          content={<>
            {
              brands.map((brand, index) => {
                return (
                  <Accordion
                    key={brand.brandName}
                    className="esfCoverageAccordion"
                  >
                 
                    <AccordionSummary
                      expandIcon={<IconChevronDown />}
                      aria-controls="panel2a-content"
                      id="panel2a-header">
                      {brand.brandName}&nbsp;&nbsp;
                      {
                        validations.find(item => item.brandId === brand.brandID)?.status === 1
                          ?
                          <IconCheckmarkCircle color="colorLightGreen6" filled></IconCheckmarkCircle>
                          : validations.find(item => item.brandId === brand.brandID)?.status === 2
                          ?
                          <IconXCircle color="colorRed6" filled></IconXCircle>
                          :
                          null
                      }
                    </AccordionSummary>

                    <AccordionDetails>
                      {brand.esfCoverageDetails.map((details, indexDetails) => {

                        if (details.typeID === 1) {
                          return (
                            <ListItem className="esfCoverageListItem" key={"details" + indexDetails} id={String(indexDetails)}
                              leadingArea={
                                <Tooltip
                                  placement="trailing"
                                  content={t("header.messageFixed")}
                                  id="tooltip"
                                ><div className="esfCoverageIconInfo"><IconInfo /><p>{t("header.fixedEsf")}</p></div></Tooltip>
                              }
                              trailingArea={
                                <Select
                                  className="esfCoverageSelect"
                                  options={optionsAdvisors}
                                  label={t("header.numberAdvisors")}
                                  placement="bottom"
                                  onChange={e => handleChangeSelectFixed(e.value, brand.brandID, details.typeID)}
                                  onClear={() => handleChangeClear(brand.brandID, details.typeID)}
                                  value={details.quantity}
                                />
                              } />

                          )

                        } else if (details.typeID === 2) {
                          return (
                            <>
                              <ListItem className="esfCoverageListItem" key={"details" + indexDetails} id={String(indexDetails)}
                                leadingArea={
                                  <Tooltip
                                    placement="trailing"
                                    content={t("header.messageRotary")}
                                    id="tooltip"
                                  ><div className="esfCoverageIconInfo"><IconInfo /><p>{t("header.rotaryEsf")}</p></div></Tooltip>
                                }
                                trailingArea={
                                  <Select
                                    className="esfCoverageSelect"
                                    options={optionsAdvisors}
                                    label={t("header.numberAdvisors")}
                                    placement="bottom"
                                    onChange={e => handleChangeSelectRotary(e.value, brand.brandID, details.typeID)}
                                    onClear={() => handleChangeClear(brand.brandID, details.typeID)}
                                    value={details.quantity}
                                  />
                                } />

                              {details.quantity.length != 0 ?

                                advisorsData.filter(item => item.brandID === brand.brandID).map((advisor, indexAdvisor) => {
                                  return (
                                    advisor.advisorDetails.map((advisorDetails, indexAdvisorDetails) => {
                                      return (
                                        <div className="esfCoverageAdvisorBlock" key={indexAdvisorDetails}>
                                          <p className="esfCoverageAdvisorTitle">{t("header.advisor")}{" " + (indexAdvisorDetails + 1)}</p>
                                          <div className="esfCoverageSelectsDetails">
                                              <div>
                                                <p className="esfCoverageFieldLabel">{t("header.dayOfWork")} <span className="esfCoverageRequired">*</span></p>
                                                <WeekdayMultiSelect
                                                label={t("header.selectADay")}
                                                options={[
                                                  { value: 1, label: t("header.monday") },
                                                  { value: 2, label: t("header.tuesday") },
                                                  { value: 3, label: t("header.wednesday") },
                                                  { value: 4, label: t("header.thursday") },
                                                  { value: 5, label: t("header.friday") },
                                                  { value: 6, label: t("header.saturday") },
                                                  { value: 7, label: t("header.sunday") },
                                                ]}
                                                value={[
                                                  ...(advisorDetails.monday ? [1] : []),
                                                  ...(advisorDetails.tuesday ? [2] : []),
                                                  ...(advisorDetails.wednesday ? [3] : []),
                                                  ...(advisorDetails.thursday ? [4] : []),
                                                  ...(advisorDetails.friday ? [5] : []),
                                                  ...(advisorDetails.saturday ? [6] : []),
                                                  ...(advisorDetails.sunday ? [7] : []),
                                                ]}
                                                onChange={(v: number) => handleChangeAdvisorWeekdays(v, brand.brandID, indexAdvisorDetails)}
                                                onClear={() => handleClearAdvisorWeekdays(brand.brandID, indexAdvisorDetails)}
                                              />
                                              </div>
                                              <div>
                                                <p className="esfCoverageFieldLabel">{t("header.advisorType")} <span className="esfCoverageRequired">*</span></p>
                                                <RadioButtons
                                                  alignment="horizontal"
                                                  name={`advisorType-${brand.brandID}-${indexAdvisorDetails}`}
                                                  value={advisorDetails.advisorType}
                                                  onChange={(e: any) => handleChangeAdvisorType(e.target.value, brand.brandID, indexAdvisorDetails)}
                                                >
                                                  <RadioButton label={t("header.partTime")} value={AdvisorType.PartTime} />
                                                  <RadioButton label={t("header.fullTime")} value={AdvisorType.FullTime} />
                                                </RadioButtons>
                                              </div>
                                              <div>
                                                <p className="esfCoverageFieldLabel">{t("header.attendanceRate")} <span className="esfCoverageRequired">*</span></p>
                                                <RadioButtons
                                                  alignment="horizontal"
                                                  name={`attendanceRate-${brand.brandID}-${indexAdvisorDetails}`}
                                                  value={advisorDetails.attendanceRate}
                                                  onChange={(e: any) => handleChangeAttendanceRate(e.target.value, brand.brandID, indexAdvisorDetails)}
                                                >
                                                  <RadioButton label={t("header.weekly")} value={AttendanceRate.Weekly} />
                                                  <RadioButton label={t("header.fortnightly")} value={AttendanceRate.Fortnightly} />
                                                  <RadioButton label={t("header.monthly")} value={AttendanceRate.Monthly} />
                                                </RadioButtons>
                                              </div>
                                          </div>
                                        </div>
                                      )

                                    })

                                  )
                                })

                                : null
                              }


                            </>
                          )
                        } else {
                          return null
                        }

                      })
                      }

                    </AccordionDetails>

                  </Accordion>
                )
              })

            }
          </>}
        />

        <div className="closingSalesSaveButton">
          <ButtonGroup>
            <Button onClick={onSaveEsfCoverage} disabled={saveDisable}>{t("header.save")}</Button>
            <Button appearance="secondary" onClick={() => navigate(-1)}>{t("header.cancel")}</Button>
          </ButtonGroup>
        </div>

        <SimpleMessageModalWithOpenClose
          showModal={showSuccess}
          setOpenCloseModal={setShowSuccess}
          modalTitle={t("header.success")}
          modalMessage={t("modal.saveSuccess")}
        />

      </div>
    </>
  );
}